import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRocket,
  faSmile,
  faShieldAlt,
  faEuroSign,
  faBolt,
  faFileAlt,
  faUserFriends,
  faFingerprint,
  faBuilding,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
// Partners data
// Import des logos des partenaires
import wbLogo from '../assets/img/wblogo.svg';
import ueLogo from '../assets/img/uelogo.svg';
import imfLogo from '../assets/img/ifmlogo.svg';
import bgFinancement from '../assets/img/log.jpg';
import bgMain from '../assets/img/168.jpg';
import teamMeeting from '../assets/img/team-meeting.jpg';
import vision from '../assets/img/vision.jpg';
import partnership from '../assets/img/partnership.jpg';
import testimony1 from '../assets/img/testimony1.jpg';
import testimony2 from '../assets/img/testimony2.jpg';
import testimony3 from '../assets/img/testimony3.jpg';

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

// Testimonies data
const testimonies = [
  {
    name: "Camille Dubois",
    text: "Grâce à l'aide financière obtenue et aux conseils du site, nous avons pu construire notre maison familiale sans encombre. Nous sommes maintenant installés dans notre nouveau chez-nous, parfaitement adapté à nos besoins. Merci pour votre aide précieuse !",
    image: testimony1,
  },
  {
    name: "Charlotte Girard",
    text: "Grâce à l'aide financière que j'ai reçue, j'ai pu réaliser mon rêve de construire mon propre ranch. Cela aurait été impossible sans ce soutien financier. Aujourd'hui, je suis fier de voir mes chevaux galoper dans de vastes prairies, et je suis reconnaissant envers ceux qui ont rendu cela possible.",
    image: testimony2,
  },
  {
    name: "Marry Mccoy",
    text: "My real estate project wouldn't have been possible without the financial help I received. Thanks to this support, I was able to invest in properties and build a legacy for the future. I am grateful to those who believed in my project and provided me with the means to make it happen.",
    image: testimony3,
  },
];

const partners = [
  {
    name: "World Bank",
    url: "https://www.worldbank.org",
    logo: wbLogo
  },
  {
    name: "Union Européenne",
    url: "https://european-union.europa.eu",
    logo: ueLogo
  },
  {
    name: "FMI",
    url: "https://www.imf.org",
    logo: imfLogo
  }
];

// Mobile Testimony Slider Component
function MobileTestimonySlider({ testimonies }) {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((prev) => (prev === 0 ? testimonies.length - 1 : prev - 1));
  const next = () => setCurrent((prev) => (prev === testimonies.length - 1 ? 0 : prev + 1));

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '16px',
    }}>
      <button
        onClick={prev}
        style={{
          padding: '12px',
          backgroundColor: '#ffffff',
          borderRadius: '50%',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          border: 'none',
          cursor: 'pointer',
          transition: 'all 0.3s',
        }}
        aria-label="Précédent"
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#1e40af';
          e.currentTarget.style.color = '#ffffff';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff';
          e.currentTarget.style.color = '#000000';
        }}
      >
        <FaChevronLeft style={{ fontSize: '18px' }} />
      </button>
      <motion.div
        style={{ width: '100%', maxWidth: '384px' }}
        variants={itemVariants}
        key={current}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.3 }}
      >
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          padding: '32px',
        }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
            <img
              alt={testimonies[current].name}
              src={testimonies[current].image}
              style={{
                width: '96px',
                height: '96px',
                borderRadius: '50%',
                objectFit: 'cover',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                border: '4px solid rgba(30, 64, 175, 0.1)',
              }}
            />
          </div>
          <h3 style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#1e293b',
            marginBottom: '16px',
            textAlign: 'center',
          }}>
            {testimonies[current].name}
          </h3>
          <p style={{
            color: '#64748b',
            lineHeight: '1.75',
            textAlign: 'center',
          }}>
            {testimonies[current].text}
          </p>
        </div>
      </motion.div>
      <button
        onClick={next}
        style={{
          padding: '12px',
          backgroundColor: '#ffffff',
          borderRadius: '50%',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          border: 'none',
          cursor: 'pointer',
          transition: 'all 0.3s',
        }}
        aria-label="Suivant"
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#1e40af';
          e.currentTarget.style.color = '#ffffff';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff';
          e.currentTarget.style.color = '#000000';
        }}
      >
        <FaChevronRight style={{ fontSize: '18px' }} />
      </button>
    </div>
  );
}

export default function Landing() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      {/* Hero Section */}
      <section
        style={{
          position: 'relative',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          backgroundImage: `linear-gradient(rgba(220, 70, 50, 0.75), rgba(0, 85, 60, 0.85)), url(${bgFinancement})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      >
        <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          background: 'linear-gradient(to bottom, rgba(30, 64, 175, 0.6), rgba(15, 23, 42, 0.8))',
        }} />
        
        <div style={{
          position: 'relative',
          zIndex: 10,
          margin: '0 auto',
          padding: '80px 16px',
          maxWidth: '1280px',
        }}>
          <motion.div
            style={{ maxWidth: '896px', margin: '0 auto', textAlign: 'center' }}
            variants={fadeIn}
            initial="hidden"
            animate="visible"
            transition={{ duration: 0.8 }}
          >
            <motion.h1
              style={{
                fontSize: 'clamp(40px, 7vw, 72px)',
                fontWeight: 'bold',
                color: '#ffffff',
                marginBottom: '32px',
                lineHeight: '1.2',
              }}
              variants={fadeInUp}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.2, duration: 0.8 }}
            >
              Obtenez un financement{" "}
              <span style={{ color: '#dc2626' }}>Non remboursable</span> en moins de 48h
            </motion.h1>

            <motion.p
              style={{
                fontSize: 'clamp(18px, 3vw, 24px)',
                color: 'rgba(255, 255, 255, 0.95)',
                marginBottom: '48px',
                maxWidth: '672px',
                margin: '0 auto 48px',
                lineHeight: '1.75',
              }}
              variants={fadeInUp}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.4, duration: 0.8 }}
            >
              Notre solution clé en main vous garantit un accompagnement personnalisé pour obtenir vos fonds rapidement et sans paperasse inutile.
            </motion.p>

            <motion.div
              variants={fadeInUp}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.6, duration: 0.8 }}
            >
              <Link
                to="/demande"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#dc2626',
                  color: '#ffffff',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  padding: '20px 40px',
                  borderRadius: '9999px',
                  boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                  textDecoration: 'none',
                  transition: 'all 0.3s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#b91c1c';
                  e.currentTarget.style.transform = 'translateY(-4px) scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(220, 38, 38, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#dc2626';
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.25)';
                }}
              >
                Demander un financement
              </Link>
            </motion.div>
          </motion.div>
        </div>

        {/* Decorative wave */}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
          <svg
            viewBox="0 0 1440 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: '100%', height: 'auto' }}
          >
            <path
              d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z"
              fill="#f8fafc"
            />
          </svg>
        </div>
      </section>

      {/* Services Cards Section */}
      <section style={{ padding: '80px 0', backgroundColor: '#f8fafc' }}>
        <div style={{ margin: '0 auto', padding: '0 16px', maxWidth: '1280px' }}>
          <motion.div
            style={{ textAlign: 'center', marginBottom: '64px' }}
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 style={{
              fontSize: 'clamp(32px, 5vw, 48px)',
              fontWeight: 'bold',
              color: '#1e293b',
              marginBottom: '16px',
            }}>
              Nos Services Financiers
            </h2>
            <p style={{
              fontSize: '18px',
              color: '#64748b',
              maxWidth: '672px',
              margin: '0 auto',
            }}>
              Découvrez nos solutions de financement adaptées à vos besoins
            </p>
          </motion.div>

          <motion.div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '32px',
              maxWidth: '1280px',
              margin: '0 auto',
            }}
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {[
              {
                title: "Aide financière non remboursable",
                description:
                  "Avec AidFoundation, bénéficiez d'une aide financière non remboursable sous forme d'un don financier provenant du budget du FMI, de la banque Mondiale et de la Banque Centrale Européenne pour vos projets de développement.",
              },
              {
                title: "Assurance vie gratuite",
                description:
                  "Pour vous permettre de garder votre sérénité, AidFoundation vous propose une assurance vie adaptée à vos besoins. À chaque projet son financement, à chaque financement son assurance, vous voici bien protégé. Une action rendue possible grâce à une collaboration entre le FMI, la Banque Mondiale et la Banque Centrale Européenne.",
              },
              {
                title: "Bourse familiale",
                description:
                  "La bourse familiale est un financement non remboursable que l'Union Européenne en Collaboration avec la Banque Mondiale a lancé pour lutter contre la pauvreté dans le monde. Veuillez vous inscrire sur la liste des bénéficiaires auprès de AidFoundation afin d'en bénéficier.",
              },
              
            ].map((card, index) => (
              <motion.div
                key={index}
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                  overflow: 'hidden',
                  transition: 'all 0.3s',
                }}
                variants={itemVariants}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.25)';
                  e.currentTarget.style.transform = 'translateY(-8px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
                  e.currentTarget.style.transform = 'none';
                }}
              >
                <div style={{
                  height: '8px',
                  background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                }} />
                <div style={{ padding: '32px' }}>
                  <h3 style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: '#1e293b',
                    marginBottom: '16px',
                    transition: 'color 0.3s',
                  }}>
                    {card.title}
                  </h3>
                  <p style={{
                    color: '#64748b',
                    lineHeight: '1.75',
                    marginBottom: '24px',
                  }}>
                    {card.description}
                  </p>
                  <Link
                    to="/demande"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      color: '#1e40af',
                      fontWeight: '600',
                      textDecoration: 'none',
                      transition: 'color 0.3s',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = '#1e3a8a';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = '#1e40af';
                    }}
                  >
                    En bénéficier
                    <svg
                      style={{
                        width: '20px',
                        height: '20px',
                        marginLeft: '8px',
                        transition: 'transform 0.3s',
                      }}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateX(4px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'none';
                      }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </Link>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Project Support Section */}
      <section style={{ padding: '80px 0', backgroundColor: '#0f172a' }}>
        <div style={{ margin: '0 auto', padding: '0 16px', maxWidth: '1280px' }}>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '48px',
            maxWidth: '1280px',
            margin: '0 auto',
          }}>
            <motion.div
              style={{ flex: '1 1 300px' }}
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '64px',
                height: '64px',
                borderRadius: '50%',
                backgroundColor: 'rgba(30, 64, 175, 0.2)',
                color: '#3b82f6',
                marginBottom: '24px',
              }}>
                <FontAwesomeIcon icon={faUserFriends} style={{ fontSize: '24px' }} />
              </div>
              <h2 style={{
                fontSize: 'clamp(32px, 5vw, 48px)',
                fontWeight: 'bold',
                color: '#ffffff',
                marginBottom: '24px',
              }}>
                Projet en quête de soutien financier
              </h2>
              <p style={{
                fontSize: '18px',
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: '1.75',
                marginBottom: '24px',
              }}>
                Besoin de financement pour concrétiser vos projets ? Notre plateforme d'aide financière est là pour vous accompagner dans la réalisation de vos rêves.
              </p>
              <p style={{
                fontSize: '18px',
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: '1.75',
              }}>
                Que ce soit pour lancer une entreprise, financer des études ou mener à bien un projet personnel, nous sommes là pour vous soutenir. Faites-nous part de votre projet et ensemble, faisons de vos ambitions une réalité.
              </p>
            </motion.div>

            <motion.div
              style={{ flex: '1 1 300px' }}
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              <div style={{
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              }}>
                <img
                  alt="Team meeting"
                  src={teamMeeting}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section style={{ padding: '80px 0', backgroundColor: '#f8fafc' }}>
        <div style={{ margin: '0 auto', padding: '0 16px', maxWidth: '1280px' }}>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '48px',
            maxWidth: '1280px',
            margin: '0 auto',
          }}>
            <motion.div
              style={{ flex: '1 1 300px', order: 2 }}
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div style={{
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              }}>
                <img
                  alt="Vision"
                  src={vision}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </motion.div>

            <motion.div
              style={{ flex: '1 1 300px', order: 1 }}
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '64px',
                height: '64px',
                borderRadius: '50%',
                backgroundColor: 'rgba(30, 64, 175, 0.2)',
                color: '#3b82f6',
                marginBottom: '24px',
              }}>
                <FontAwesomeIcon icon={faRocket} style={{ fontSize: '24px' }} />
              </div>
              <h2 style={{
                fontSize: 'clamp(32px, 5vw, 48px)',
                fontWeight: 'bold',
                color: '#1e293b',
                marginBottom: '24px',
              }}>
                Notre vision et nos valeurs
              </h2>
              <p style={{
                fontSize: '18px',
                color: '#64748b',
                lineHeight: '1.75',
                marginBottom: '32px',
              }}>
                Nos aides financières non remboursables désignent des sommes d'argent accordées à titre de dons, vous n'aurez donc pas à rembourser. Nous facilitons la demande en faisant nous-même toutes les démarches administratives que vous soyez un interdit bancaire ou non.
              </p>

              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {[
                  {
                    icon: faFingerprint,
                    text: "Lutter contre la pauvreté dans le monde entier",
                  },
                  {
                    icon: faBuilding,
                    text: "Aider à la création de nouvelles entreprises de développement",
                  },
                  {
                    icon: faPaperPlane,
                    text: "Encourager les projets personnels de développement",
                  },
                ].map((item, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', marginBottom: '16px' }}>
                    <div style={{
                      flexShrink: 0,
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(30, 64, 175, 0.2)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#3b82f6',
                    }}>
                      <FontAwesomeIcon icon={item.icon} />
                    </div>
                    <p style={{
                      color: '#1e293b',
                      fontWeight: '500',
                      paddingTop: '8px',
                      margin: 0,
                    }}>
                      {item.text}
                    </p>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section style={{ padding: '80px 0', backgroundColor: '#0f172a' }}>
        <div style={{ margin: '0 auto', padding: '0 16px', maxWidth: '1280px' }}>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '48px',
            maxWidth: '1280px',
            margin: '0 auto',
          }}>
            <motion.div
              style={{ flex: '1 1 300px' }}
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div style={{
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              }}>
                <img
                  alt="Partnership"
                  src={partnership}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </motion.div>

            <motion.div
              style={{ flex: '1 1 300px' }}
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              <h2 style={{
                fontSize: 'clamp(32px, 5vw, 48px)',
                fontWeight: 'bold',
                color: '#ffffff',
                marginBottom: '24px',
              }}>
                Pourquoi nous choisir ?
              </h2>

              <p style={{
                fontSize: '18px',
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: '1.75',
                marginBottom: '32px',
              }}>
                Avec l'appui du FMI, de la Banque Mondiale et de la Banque Centrale Européenne nous mettons à votre disposition tout type de financement non remboursable. Nos conseillers sont à votre disposition 24h/24 pour répondre à vos diverses questions. Nos opérations sont rapides, en toute sécurité et transparence. C'est le moment d'innover pour changer le monde.
              </p>

              <div style={{ marginBottom: '32px' }}>
                {[
                  {
                    icon: faRocket,
                    text: "Financement non remboursable rapide 100% en ligne",
                  },
                  {
                    icon: faSmile,
                    text: "Tous nos clients sont entièrement satisfaits",
                  },
                  {
                    icon: faShieldAlt,
                    text: "Vos données sont sécurisées et protégées",
                  },
                ].map((item, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', marginBottom: '24px' }}>
                    <div style={{
                      flexShrink: 0,
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(220, 38, 38, 0.2)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#dc2626',
                    }}>
                      <FontAwesomeIcon icon={item.icon} />
                    </div>
                    <p style={{
                      color: '#ffffff',
                      fontWeight: '500',
                      paddingTop: '8px',
                      margin: 0,
                    }}>
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>

              <Link
                to="/demande"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#dc2626',
                  color: '#ffffff',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  padding: '16px 32px',
                  borderRadius: '9999px',
                  boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                  textDecoration: 'none',
                  transition: 'all 0.3s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#b91c1c';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(220, 38, 38, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#dc2626';
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.25)';
                }}
              >
                Demander un financement
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section style={{ padding: '80px 0', backgroundColor: '#f8fafc' }}>
        <div style={{ margin: '0 auto', padding: '0 16px', maxWidth: '1280px' }}>
          <motion.div
            style={{ textAlign: 'center', marginBottom: '64px' }}
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 style={{
              fontSize: 'clamp(32px, 5vw, 48px)',
              fontWeight: 'bold',
              color: '#1e293b',
              marginBottom: '16px',
            }}>
              Obtenez une aide financière sans remboursement
            </h2>
            <p style={{
              fontSize: '18px',
              color: '#64748b',
              maxWidth: '768px',
              margin: '0 auto',
            }}>
              Nous offrons un soutien financier immédiat{" "}
              <span style={{ fontWeight: '600', color: '#1e40af' }}>
                sans aucune obligation de remboursement
              </span>
              , pour vous aider à concrétiser vos projets personnels ou professionnels.
            </p>
          </motion.div>

          <motion.div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '32px',
              maxWidth: '960px',
              margin: '0 auto',
            }}
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {[
              {
                icon: faEuroSign,
                title: "Aide financière directe",
                description:
                  "Recevez un montant fixe sans avoir à le rembourser, pour vos besoins immédiats ou vos projets à venir.",
              },
              {
                icon: faBolt,
                title: "Délais rapides",
                description:
                  "Obtention des fonds en 48 heures maximum après validation de votre dossier.",
              },
              {
                icon: faFileAlt,
                title: "Dossier simplifié",
                description:
                  "Une demande en ligne sans paperasse complexe et sans conditions restrictives.",
              },
            ].map((item, index) => (
              <motion.div
                key={index}
                style={{ textAlign: 'center' }}
                variants={itemVariants}
              >
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '64px',
                  height: '64px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(30, 64, 175, 0.1)',
                  color: '#1e40af',
                  marginBottom: '24px',
                }}>
                  <FontAwesomeIcon icon={item.icon} style={{ fontSize: '24px' }} />
                </div>
                <h3 style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1e293b',
                  marginBottom: '12px',
                }}>
                  {item.title}
                </h3>
                <p style={{
                  color: '#64748b',
                  lineHeight: '1.75',
                }}>
                  {item.description}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Partners Section */}
      <section style={{ padding: '80px 0', backgroundColor: '#f8fafc' }}>
        <div style={{ margin: '0 auto', padding: '0 16px', maxWidth: '1280px' }}>
          <motion.div
            style={{ textAlign: 'center', marginBottom: '48px' }}
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 style={{
              fontSize: 'clamp(32px, 5vw, 48px)',
              fontWeight: 'bold',
              color: '#1e293b',
              marginBottom: '16px',
            }}>
              Nos Partenaires
            </h2>
            <p style={{
              fontSize: '18px',
              color: '#64748b',
            }}>
              En collaboration avec les plus grandes institutions financières mondiales
            </p>
          </motion.div>

          <motion.div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-around',
              alignItems: 'center',
              gap: '40px',
              maxWidth: '900px',
              margin: '0 auto',
              padding: '0 20px',
            }}
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {partners.map((partner, index) => (
              <motion.a
                key={index}
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  filter: 'grayscale(100%)',
                  transition: 'all 0.3s',
                }}
                variants={itemVariants}
                onMouseEnter={(e) => {
                  e.currentTarget.style.filter = 'grayscale(0%)';
                  e.currentTarget.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.filter = 'grayscale(100%)';
                  e.currentTarget.style.transform = 'none';
                }}
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  style={{
                    height: '70px',
                  maxHeight: '80px',
                  width: 'auto',
                  maxWidth: '200px',
                  objectFit: 'contain'
                  }}
                />
              </motion.a>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section style={{
        padding: '80px 0',
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        color: '#ffffff',
      }}>
        <div style={{ margin: '0 auto', padding: '0 16px', maxWidth: '1280px', textAlign: 'center' }}>
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 style={{
              fontSize: 'clamp(32px, 5vw, 48px)',
              fontWeight: 'bold',
              marginBottom: '24px',
            }}>
              Prêt à concrétiser vos projets ?
            </h2>
            <p style={{
              fontSize: '20px',
              marginBottom: '40px',
              maxWidth: '672px',
              margin: '0 auto 40px',
              opacity: 0.95,
            }}>
              Rejoignez des milliers de bénéficiaires qui ont obtenu leur financement non remboursable en moins de 48h
            </p>
            <Link
              to="/demande"
              style={{
                display: 'inline-block',
                backgroundColor: '#ffffff',
                color: '#1e40af',
                fontWeight: 'bold',
                fontSize: '18px',
                padding: '20px 40px',
                borderRadius: '9999px',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                textDecoration: 'none',
                transition: 'all 0.3s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f9fafb';
                e.currentTarget.style.transform = 'translateY(-4px) scale(1.05)';
                e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#ffffff';
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.25)';
              }}
            >
              Faire une demande maintenant
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
